const Occurence = ({ occurence }) => {
  return ['1st', '2nd', '3rd', '4th', '5th'][occurence - 1];
};

export default Occurence;
